import React, { useState, useEffect, useContext } from 'react';
import GestaoUsuario from '../../../usuario/gestao/index';
import Badge from '@material-ui/core/Badge';
import UserConfig from "../../../../images/icons/user-config-icon.svg";
import Hourglass from "../../../../images/icons/hourglass-icon.svg"
import { getNaoAprovados} from '../../../../services/usuario/UsuarioService';
import { countNaoAprovados } from '../../../../services/usuario/UsuarioService'
import useStyles from './styles';
import Historico from '../../../historico';
import { getAll } from '../../../../services/historico/HistoricoService';
import { ClickAwayListener } from '@material-ui/core';

const RightSidebar = () => {

  const classes = useStyles();
  const [quantidadeUsuarios, setQuantidadeUsuarios] = useState(0);
  const [conselheiros, setConselheiros] = useState([]);
  const [equipeTecnica, setEquipeTecnica] = useState([]);
  const [interlocutores, setInterlocutores] = useState([]);
  const [openConvite, setOpenConvite] = useState(false);
  const [openHistorico, setOpenHistorico] = useState(false);
  const [historico, setHistorico] = useState([]);

  const [filtro] = useState({
    quantidadeDias: '',
    busca: '',
  })

  useEffect(() => {
    quantidadeNaoAprovados();
  }, [])

  const quantidadeNaoAprovados = () => {
    countNaoAprovados().then((response) => {
      if (response && response.status === 200) {
        const { data } = response;
        setQuantidadeUsuarios(data);
      }
    })
  }

  const handleOpenConvite = () => {
    setOpenHistorico(false);
    setOpenConvite(!openConvite)
    conselheirosNaoAprovados();
    equipeTecnicaNaoAprovados();
    interlocutoresNaoAprovados();
  }

  const conselheirosNaoAprovados = async () => {
    const response = await getNaoAprovados('CONSELHEIRO');
    if (response && response.status == 200) {
      const { data } = response;
      setConselheiros(data)
    }
  }

  const equipeTecnicaNaoAprovados = async () => {
    const response = await getNaoAprovados('EQUIPE_TECNICA');
    if (response && response.status == 200) {
      const { data } = response;
      setEquipeTecnica(data)
    }
  }

  const interlocutoresNaoAprovados = async () => {
    const response = await getNaoAprovados('INTERLOCUTOR');
    if (response && response.status == 200) {
      const { data } = response;
      setInterlocutores(data)
    }
  }
  const abrirHistory = async () => {
    setOpenConvite(false);
    setOpenHistorico(!openHistorico)
    const response = await getAll(filtro);

    if (response && response.status === 200) {
      const { data } = response;
      setHistorico(data)
    }
  }

  const handleClickAway = () => {
    if (openConvite) {
      setOpenConvite(false);
    } else if (openHistorico) {
      setOpenHistorico(false)
    }
  }
  
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div className={classes.bar}>
        <div className={openConvite ? classes.iconsBoxActive : classes.iconsBox}>
          <Badge
            onClick={handleOpenConvite}
            badgeContent={quantidadeUsuarios}
            classes={{
              colorPrimary: classes.colorPrimary
            }}
            color="primary">
            <img className={classes.icons} src={UserConfig} onClick={handleOpenConvite} />
          </Badge>
        </div>
        <div className={openHistorico ? classes.iconsBoxActive : classes.iconsBox}>
          <img style={{ margin: '5px 5px 0 5px' }} className={classes.icons} src={Hourglass} onClick={abrirHistory} />
        </div>
        <GestaoUsuario
          open={openConvite}
          onClose={() => setOpenConvite(false)}
          conselheiros={conselheiros}
          equipeTecnica={equipeTecnica}
          interlocutores={interlocutores}
          onAction={quantidadeNaoAprovados} />
        <Historico
          open={openHistorico}
          historico={historico}
          onClose={() => setOpenHistorico(false)} />
      </div>
    </ClickAwayListener>

  )
};

export default RightSidebar;
